module.exports = __webpack_public_path__ + "static/media/Commcryptlogo.e5ed4e60.png";